export default "__VITE_ASSET__DUYF60Eu__"